var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function BroadQueryIcon(_a) {
    var { fillColor, opacity } = _a, props = __rest(_a, ["fillColor", "opacity"]);
    return (React.createElement("svg", Object.assign({ width: "10", height: "10", viewBox: "0 0 10 10", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { id: "Vector", d: "M5 10L2.9625 7.9625L3.5125 7.4125L4.625 8.525V6.1625H5.375V8.525L6.4875 7.4125L7.0375 7.9625L5 10ZM1.975 6.975L0 5L1.9875 3.0125L2.5375 3.5625L1.475 4.625H3.8375V5.375H1.475L2.525 6.425L1.975 6.975ZM8.025 6.975L7.475 6.425L8.525 5.375H6.175V4.625H8.525L7.475 3.575L8.025 3.025L10 5L8.025 6.975ZM4.625 3.825V1.475L3.575 2.525L3.025 1.975L5 0L6.975 1.975L6.425 2.525L5.375 1.475V3.825H4.625Z", fill: fillColor, fillOpacity: opacity })));
}
export default memo(withIconDefaults(BroadQueryIcon));
